import React, { useState } from 'react';
import Card from '../components/Card';
import Masonry from 'react-masonry-css';
import Header from '../components/Header';

function Portfolio({ projects }) {  // Receive projects as a prop
    const [selectedCategory, setSelectedCategory] = useState('All');
    console.log(projects);

    const categories = ['All', 'Hospitality', 'Healthcare', 'Commercial', 'Institution', 'Masterplan'];

    const displayedProjects = selectedCategory === 'All' ? projects : projects.filter(project => project.category === selectedCategory);

    let sortedProjects = [...displayedProjects].sort((a, b) => {
        let orderA = a.order === null ? Infinity : a.order;
        let orderB = b.order === null ? Infinity : b.order;
        return orderA - orderB;
    });

    console.log(sortedProjects);

    const breakpointColumnsObj = {
        default: 2,
        768: 1
    };

    return (
        <div className="bg-[#e5dedb] min-h-screen">
            <Header />
            <div id="projects" className="pt-24 py-8 md:px-[15%] bg-e5dedb ">
                <div className="form-progress mb-4 flex flex-wrap justify-center md:space-x-4 w-full">
                    {categories.map((category, idx) => (
                        <div
                            key={category}
                            className={`form-stage cursor-pointer border-r border-gray-300 ${selectedCategory === category ? ' text-gold-500' : ' text-gray-500'} md:flex-1 text-center`}
                            onClick={() => setSelectedCategory(category)}
                            style={idx === categories.length - 1 ? { borderRight: 'none' } : {}}
                        >
                            <h2 className="form-stage-title text-md md:text-xl font-medium px-2">{category}</h2>
                        </div>
                    ))}
                </div>

                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className={`my-masonry-grid min-h-[75vh]`} // minimum height added
                    columnClassName="my-masonry-grid_column"
                >
                    {sortedProjects.map((project) => (
                        <Card key={`${project.title}-${project.subtitle}`} {...project} />
                    ))}
                </Masonry>
            </div>
        </div>
    );
}

export default Portfolio;
